// src/components/Navbar.js
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";
import { FaBell } from "react-icons/fa";
import axios from "axios";
import { getAuth, signOut } from "firebase/auth";

const Navbar = () => {
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);
  const userId = localStorage.getItem("customerId");
  const isLoggedIn = !!userId;

  // ✅ Handle logout safely
  const handleLogout = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login", { replace: true });
      })
      .catch((error) => {
        console.error("❌ Logout failed:", error);
        localStorage.clear();
        navigate("/login", { replace: true });
      });
  };

  // ✅ Fetch unread notifications
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        if (userId && userId.length === 24) {
          const res = await axios.get(
            `${process.env.REACT_APP_API_BASE}/api/notification/unread/${userId}`
          );
          setUnreadCount(res.data.count || 0);
        }
      } catch (err) {
        console.error("❌ Failed to fetch notifications", err);
      }
    };
    fetchNotifications();
  }, [userId]);

  // ✅ Handle protected routes cleanly
  const handleProtectedClick = (route) => {
    if (!isLoggedIn) {
      navigate("/login", { replace: true });
    } else {
      navigate(route);
    }
  };

  return (
    <nav
      className="
        flex items-center justify-between 
        px-6 md:px-10 py-3 
        shadow-md border-b border-white/30 
        bg-white/70 backdrop-blur-xl 
        md:bg-white md:backdrop-blur-none 
        transition-all duration-300
      "
    >
      {/* Left Side: Logo */}
      <div className="flex items-center space-x-2">
        <h1 className="text-xl md:text-2xl font-extrabold text-blue-600 select-none">
          <span className="text-blue-600">Book</span>{" "}
          <span className="text-indigo-600">Your</span>{" "}
          <span className="text-blue-600">Need</span>
        </h1>
      </div>

      {/* Middle Menu (hidden on mobile) */}
      <div className="hidden md:flex items-center space-x-8 text-lg font-semibold text-gray-700">
        <Link to="/welcome" className="hover:text-blue-600">
          Home
        </Link>
        <span
          onClick={() => handleProtectedClick("/your-jobs")}
          className="cursor-pointer hover:text-blue-600"
        >
          Your Jobs
        </span>
        <span
          onClick={() => handleProtectedClick("/profile")}
          className="cursor-pointer hover:text-blue-600"
        >
          Profile
        </span>
        <span
          onClick={() => handleProtectedClick("/wallet")}
          className="cursor-pointer hover:text-blue-600"
        >
          Wallet
        </span>
        <span
          onClick={() => handleProtectedClick("/help")}
          className="cursor-pointer hover:text-blue-600"
        >
          Help
        </span>
        <div
          className="relative cursor-pointer"
          onClick={() => handleProtectedClick("/notifications")}
        >
          <FaBell className="text-xl hover:text-blue-600" />
          {unreadCount > 0 && (
            <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
              {unreadCount}
            </span>
          )}
        </div>
      </div>

      {/* Right Side: Logout */}
      <div>
        <button
          onClick={handleLogout}
          className="
            flex items-center 
            bg-red-500 hover:bg-red-600 
            text-white px-4 md:px-5 py-2 
            rounded-full font-bold 
            text-sm md:text-base 
            transition-all duration-300
          "
        >
          <FiLogOut className="mr-2" />
          Logout
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
